function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Artboard");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 5.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 7,
  cy: 2,
  r: 1.522
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 1.672,
  cy: 2,
  r: 1.522
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12.328,
  cy: 2,
  r: 1.522
})));

var SvgMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/more.50a093f8.svg";
export { SvgMore as ReactComponent };